import "./index_tabs.scss";